// Versione corrente delle novità mostrate nel WhatsNewDialog.
// Bump questa stringa a ogni rilascio con feature da comunicare:
// gli utenti il cui campo Firestore `whatsNewSeen` è diverso da questa
// stringa vedranno di nuovo il popup al prossimo login.
export const CURRENT_WHATS_NEW_VERSION = '2026.06.qa-fix';
